<div class="cal-freq-mat-calendar">
  <mat-calendar
    [selected]="selectedDate"
    (selectedChange)="onSelectedChange($event)"
    [startAt]="startAtDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [dateFilter]="dateFilterFn"
    [dateClass]="dateClassFn"
  ></mat-calendar>
</div>
